import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled.article`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;

  ${({ theme }) => `${theme.breakpoints.xxl} {
      display: grid;
      grid-template-rows: none;
      grid-template-columns: 50% 50%;
    }
  `}
`;

export const SlideShowWrapper = styled.article`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: auto;

  ${({ theme }) => `${theme.breakpoints.md} {
    width: 400px;
  }
`}
`;
export const SlideShowWrapperliveshows = styled.section`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: auto;

  ${({ theme }) => `${theme.breakpoints.md} {
    width: 100%;
  }
`}
`;

export const Label = styled.p`
  font-size: 0.75rem;
  margin-bottom: var(--space-50);
  order: 1;
`;

export const Content = styled.div`
  padding: var(--space-50) var(--space-100) var(--space-100);
  background-color: var(--colour-bg-alternative);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  order: 2;
  > *:not(${Label}) {
    order: 2;
  }
  ${({ theme }) => `${theme.breakpoints.sm} {
    padding: var(--space-50) 0 0;
  }
`}
`;

export const Children = styled.div`
  margin-bottom: var(--space-100);
`;

export const Title = styled.h2`
  margin-bottom: var(--space-150);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
  margin-bottom: 1rem;
`;

export const Eventtitle = styled.span`
  margin-bottom: var(--space-150);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
  margin-bottom: 1rem;
  font-size:1.22rem;
  font-weight: 700;
  overflow-wrap: anywhere;
`;

export const ImageWrapper = styled.div`
  overflow: hidden;
  position: relative;
  order: 1;
`;

export const ButtonWrapper = styled.div`
  margin-top: var(--space-50);
`;
export const ArrowIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  border: 1.5px solid currentColor;
  background-color: var(--colour-neutral-white);
`;

export const CardLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  height: 100%;
  cursor: pointer;

  &:hover,
  &:focus {
    text-decoration: none;
    color: inherit;
  }

  &:focus-visible {
    outline: 2px solid var(--colour-focus, #0058a3);
    outline-offset: 2px;
  }

  &:hover ${Eventtitle},
  &:focus-visible ${Eventtitle} {
    text-decoration: underline;
    font-weight: 700;
  }

  &:hover ${ArrowIcon},
  &:focus-visible ${ArrowIcon} {
    border-width: 2.5px;
    svg {
      stroke-width: 2;
    }
  }
`;